import { render, staticRenderFns } from "./PlanListAddNew.vue?vue&type=template&id=5e12ffc9"
import script from "./PlanListAddNew.vue?vue&type=script&lang=js"
export * from "./PlanListAddNew.vue?vue&type=script&lang=js"
import style0 from "./PlanListAddNew.vue?vue&type=style&index=0&id=5e12ffc9&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports